// extracted by mini-css-extract-plugin
export var chevron = "_1a-d";
export var disabled = "_1a-b";
export var error = "_1a-c";
export var hideBorder = "_1a-1";
export var icon = "_1a-e";
export var input = "_1a-0";
export var large = "_1a-f";
export var open = "_1a-9";
export var placeholder = "_1a-a";
export var regular = "_1a-5";
export var singleRowInput = "_1a-2";
export var singleSelectInput = "_1a-3 _1a-0";
export var small = "_1a-4";
export var spinnerContainer = "_1a-i";
export var tag = "_1a-7";
export var tagsContainer = "_1a-8";
export var tagsInput = "_1a-6 _1a-0";
export var xSmall = "_1a-g";
export var xxSmall = "_1a-h";